import { api } from '@/integrations/clients/carAuction/carAuctionClient';
import { 
  GetAllFavoritesResponse,
  AddFavoriteResponse,
  RemoveFavoriteResponse,
} from "@/types/favorite";
import { ListingOverview } from "@/types/listing";

export class FavoriteService {

  // Get all favorites for a user
  static async getAllFavorites(userId: string): Promise<GetAllFavoritesResponse> {
    const response = await api.get<{
      success: boolean;
      favorites: ListingOverview[];
      totalCount: number;
    }>("/favorites");
    
    return {
      favorites: response.favorites || [],
      totalCount: response.totalCount || 0,
    };
  }

  // Add favorite for a listing
  static async addFavorite(listingId: string, userId: string): Promise<AddFavoriteResponse> {
    const response = await api.post<{
      success: boolean;
      favoriteId?: string;
      message?: string;
    }>("/favorites", { listingId });
    
    return {
      message: response.message || "Annons tillagd till favoriter",
    };
  }

  // Remove favorite for a listing
  static async removeFavorite(listingId: string, userId: string): Promise<RemoveFavoriteResponse> {
    const response = await api.delete<{
      success: boolean;
      message?: string;
    }>(`/favorites/${listingId}`);
    
    return {
      message: response.message || "Annons borttagen från favoriter",
    };
  }

}
